import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader, Loading, ErrorState } from "@/components/States";
import FlashcardViewer from "@/components/FlashcardViewer";
import { api, formatError } from "@/lib/api";

export default function DeckView() {
  const { id } = useParams();
  const [deck, setDeck] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/flashcards/${id}`).then((r) => setDeck(r.data)).catch((e) => setErr(formatError(e))); }, [id]);
  if (err) return <ErrorState message={err} />;
  if (!deck) return <Loading />;
  const known = deck.cards.filter((c) => c.status === "known").length;
  const revise = deck.cards.filter((c) => c.status === "revise").length;
  return (
    <div>
      <Link to="/flashcards" data-testid="deck-back-link" className="mb-6 inline-flex items-center gap-2 text-sm text-ink-3 hover:text-ink"><ArrowLeft className="h-4 w-4" />All decks</Link>
      <PageHeader eyebrow={deck.subject_name} title={deck.topic} text={`${deck.cards.length} cards · ${deck.difficulty}`}>
        <div className="flex gap-4 text-sm">
          <span data-testid="deck-known-count" className="text-emerald-700"><b>{known}</b> known</span>
          <span data-testid="deck-revise-count" className="text-amber-700"><b>{revise}</b> to revise</span>
        </div>
      </PageHeader>
      <FlashcardViewer deck={deck} onChange={setDeck} />
    </div>
  );
}
